module.exports = __webpack_public_path__ + "static/img/img33.941da6cd.png";